export default __webpack_public_path__ + "static/mimino-3e4a9ae55d345a2e9e79f3fdf0155652.png";